import React from 'react';
import './Header.css';
import IconSVG from "../IconSVG";
import {smartGoBack} from "../../utils/smartNavigate";

interface SimpleHeaderProps {
  title: string;
  rightButton?: {
    icon: string;
    onClick: () => void;
    ariaLabel?: string;
  };
}

const SimpleHeader: React.FC<SimpleHeaderProps> = ({ title, rightButton }) => {
  // const navigate = useNavigate();

  const handleBack = () => {
    smartGoBack()
    // navigate(-1);
  };

  return (
    <header className="header simple-header">
      <div className="header__left">
        <button
          className="header__back-button"
          onClick={handleBack}
          aria-label="Go back"
        >
          <IconSVG path={'/images/ui-svg/arrow-left.svg'} size={24}/>
        </button>
      </div>
      <div className="header__center">
        <h1 className="simple-header__title">{title}</h1>
      </div>
      <div className="header__right">
        {rightButton ? (
          <button
            className="header__right-button"
            onClick={rightButton.onClick}
            aria-label={rightButton.ariaLabel || 'Action button'}
          >
            <img
              src={rightButton.icon}
              alt={rightButton.ariaLabel || 'Action'}
              width="24"
              height="24"
            />
          </button>
        ) : (
          /* Empty space for layout balance */
          <div style={{ width: '40px', height: '40px' }} />
        )}
      </div>
    </header>
  );
};

export default SimpleHeader;
